import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { ADMIN_TRANSLATIONS } from '../i18n/translations';

@Pipe({ name: 'translate', pure: false, standalone: false })
export class TranslatePipe implements PipeTransform {
  constructor(private langService: LanguageService) {}
  transform(key: string): string {
    return ADMIN_TRANSLATIONS[this.langService.current]?.[key] ?? key;
  }
}
